
import { mapState } from 'vuex'
import { diagramToAnalyticsItem, removeHtml } from '@/utils/helpers'
import promoBanner from '~/components/banners/promoBaner'

function pickCategoryProps (category) {
  return {
    id: category.id,
    name: category.name,
    url: category.url,
    parent: category.parent,
    children: category.children,
    description_intro: category.description_intro,
    description_more: category.description_more,
    meta_description: category.description_more,
    diagrams: category.diagrams
  }
}

export default {
  components: {
    promoBanner
  },
  transition: 'page',
  async asyncData ({
    params,
    payload,
    $backend,
    error
  }) {
    try {
      if (payload) {
        return {
          category: pickCategoryProps(payload.category)
        }
      } else {
        let category
        if (Number.isInteger(params.category)) {
          category = await $backend.categories.retrieve(params.category)
          return { category }
        } else {
          const category = await $backend.categories.get({ url: removeHtml(params.category) }).then(d => d.results[0])
          if (!category) {
            error({
              statusCode: 404,
              message: `Category ${params.category} not found`
            })
          }
          return {
            category: pickCategoryProps(category)
          }
        }
      }
    } catch (e) {
      error({
        statusCode: 404,
        message: `Category ${params.category} not found`
      })
    }
  },

  head () {
    return {
      title: `${this.category.name} slides`,
      bodyAttrs: {
        class: 'page-category'
      },
      description: this.metaDescription,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.category.title
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: this.canonicalUrl
        },
        {
          hid: 'description',
          name: 'description',
          content: this.metaDescription
        }
      ]
    }
  },
  computed: {
    ...mapState(['menuCategories', 'categories']),
    listName () {
      return 'Diagrams in category ' + this.category.name
    },
    canonicalUrl () {
      return `/category/${this.category.url}`
    },
    metaDescription () {
      return this.category.meta_description || this.category.title
    }
  },
  mounted () {
    this.$store.commit('setCurrentCategory', {
      id: this.category.id,
      parent: this.category.parent
    })
    this.$gtag.event(
      'view_item_list',
      {
        items: this.category.diagrams.map((diagram, index) => ({
          ...diagramToAnalyticsItem(diagram, index),
          list_name: this.listName
        }))
      }
    )
  },
  methods: {
    async getLatestDiagrams (category) {
      const diagrams = await this.$backend.diagrams.get({
        categories: category,
        ordering: '-refresh_date',
        page_size: 3
      }).then(d => d.results)
      return { diagrams }
    }
  }
}
